export const isString = (val) => (typeof val === 'string' || val instanceof String);
